import { Button, DateField, useTable, Icons, Modal, ShowButton, Table, useModal, Tooltip } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { definitions } from 'interfaces'
import { currency, DEFAULT_DATE_TIME_FORMAT, ORDER_STATUS_ID_SUBSCRIPTION } from 'utility'

type ModalProps = {
  userId: number
}

export const UserSubscriptionOrdersModal: React.FC<ModalProps> = ({ userId }) => {
  const { modalProps, show } = useModal()
  const t = useTranslate()

  const { tableProps } = useTable<definitions['orders']>({
    resource: 'orders',
    metaData: {
      select: 'id, created_at, total'
    },
    permanentFilter: [
      {
        field: 'user_id',
        operator: 'eq',
        value: userId
      },
      {
        field: 'status_id',
        operator: 'eq',
        value: ORDER_STATUS_ID_SUBSCRIPTION
      }
    ],
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc'
      }
    ]
  })

  return (
    <>
      <Tooltip title={t('subscriptions.view_orders')}>
        <Button onClick={show} size="small" className="ant-btn ant-btn-primary">
          <Icons.EuroCircleOutlined />
        </Button>
      </Tooltip>

      <Modal
        {...modalProps}
        title={t('order.orders')}
        centered
        footer={null}
        style={{ minWidth: '50svw' }}
      >
        <Table {...tableProps} dataSource={tableProps.dataSource} rowKey='id'>
          <Table.Column
            key="id"
            dataIndex="id"
            title={t('order.fields.id')}
            align="center"
            render={(value) => (
              <ShowButton
                resourceNameOrRouteName='orders'
                recordItemId={value}
              >
                {`#${value}`}
              </ShowButton>
            )}
          />
          <Table.Column
            key='created_at'
            dataIndex={['created_at']}
            title={t('order.fields.date')}
            render={(value) => value ? <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/> : null}
            align='center'
          />
          <Table.Column
            key="total"
            dataIndex="total"
            title={t('order.fields.total')}
            align="center"
            render={(value) => currency(value)}
          />
          </Table>
      </Modal>
    </>
  )
}
